// https://vuex.vuejs.org/en/state.html
import { getStorageItem, getStorageJSON } from './storage'

export default {
  authStatus: '',
  token: getStorageItem('token', ''),
  user: getStorageItem('user', ''),
  ids_roles: getStorageJSON('ids_roles', []),
  ids_vistas: getStorageJSON('ids_vistas', []),
  ids_unidades_medicas: getStorageJSON('ids_unidades_medicas', []),
  id_unidad_medica_activa: getStorageItem('id_unidad_medica_activa', ''),
  nombre: getStorageItem('nombre', ''),
  apellido_paterno: getStorageItem('apellido_paterno', ''),
  apellido_materno: getStorageItem('apellido_materno', ''),
  es_medico: getStorageJSON('es_medico', false),
  configuracion_doctor: getStorageJSON('configuracion_doctor', false),
  es_admin: getStorageJSON('es_admin', false),
  extemporaneo: getStorageJSON('extemporaneo', false),
  vinculado: getStorageJSON('vinculado', true),
  expediente_validado: getStorageJSON('expediente_validado', true),
  storage_url: '',
}
